const renderOptions = (data) => {
    return (
        <>
            <option value="">Select an option...</option>
            {data && data.map((item) => (
                <option key={item.id} value={item.attributes.Label || item.attributes.ISO2}>
                    {item.attributes.Label || item.attributes.Name}
                </option>
            ))}
        </>
    );
};

export { renderOptions };



const renderOptionsMultiple = (data, selectedValues) => {
    return (
        <>
            <option value="">Select an option...</option>
            {data.map((item) => (
                <option
                    key={item.id}
                    value={item.attributes.Label || item.attributes.ISO2}
                    selected={selectedValues.includes(item.attributes.Label || item.attributes.ISO2)}
                >
                    {item.attributes.Label || item.attributes.Name}
                </option>
            ))}
        </>
    );
};

export { renderOptionsMultiple };

